import app from 'flarum/forum/app';
import {ApiPayloadPlural} from 'flarum/common/Store';
import Form from '../models/Form';
import File from '../models/File';

export default class Uploader {
    form: Form
    uploading: boolean = false

    constructor(form: Form) {
        this.form = form;
    }

    upload(files: FileList | null, key: string): Promise<File[]> {
        if (!files) {
            return Promise.reject();
        }

        const body = new FormData();

        for (let i = 0; i < files.length; i++) {
            body.append(key + '[]', files[i]);
        }

        this.uploading = true;
        m.redraw();

        return new Promise((resolve, reject) => {
            app.request<ApiPayloadPlural>({
                method: 'POST',
                url: app.forum.attribute('apiUrl') + this.form.apiEndpoint() + '/upload',
                serialize: (raw: any) => raw,
                body,
            }).then(result => {
                this.uploading = false;
                m.redraw();

                resolve(app.store.pushPayload<File[]>(result));
            }).catch(err => {
                this.uploading = false;
                m.redraw();

                reject(err);
            });
        });
    }
}
